const normalized = (value) => String(value || "").trim().toLowerCase();
const contains = (values, value) => Array.isArray(values) && values.some((entry) => normalized(entry) === value);

export function scopedMatch(systemName, id, record, scope) {
  const email = normalized(scope.learnerEmail);
  const uid = normalized(scope.learnerUid);
  const intakeIds = new Set((scope.intakeBlockIds || []).map(normalized).filter(Boolean));
  const name = normalized(systemName);
  if (["learnerassessmentstory", "assessmentsubmissions", "quizsubmissions"].includes(name)) {
    const owner = !email && !uid ||
      email && [record.learnerEmail, record.email, record.userEmail].some((value) => normalized(value) === email) ||
      name === "learnerassessmentstory" && uid && [id, record.learnerUid, record.uid].some((value) => normalized(value) === uid);
    const assessment = normalized(scope.assessmentId);
    return Boolean(owner && (!assessment ||
      [record.assessmentId, record.assessmentUid, record.assessmentUniqueId].some((value) => normalized(value) === assessment)));
  }
  if (name === "intakeblocks") {
    return !email && !intakeIds.size ||
      [id, record.id, record.uid, record.name, record.docId].some((value) => intakeIds.has(normalized(value))) ||
      email && contains(record.learnerIds, email);
  }
  if (name === "assessments") {
    return !email && !intakeIds.size ||
      [record.intakeBlockId, record.intakeBlockUid, record.intakeId, record.intakeBlockName, record.intakeName,
        ...(Array.isArray(record.intakeBlockIds) ? record.intakeBlockIds : [])]
        .some((value) => intakeIds.has(normalized(value))) ||
      email && (contains(record.targetLearnerIds, email) || contains(record.summativeDetails?.targetLearnerIds, email));
  }
  if (name === "livesessions") {
    return !email && !intakeIds.size || intakeIds.has(normalized(record.intakeId)) || email && contains(record.learnerIds, email);
  }
  if (["learnerresources", "facilitatorresources"].includes(name)) {
    return !intakeIds.size || intakeIds.has(normalized(record.intakeId));
  }
  return true;
}
